import { useCallback } from 'react';
import { usePageViewEvents } from '../../../../../../../core/Analytics/usePageViewEvents';
import { PageView, UserInteractionEvent } from '../../../../../../../models/analytics';
import { SubmitProviderInputsPayload } from '../../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import {
  CheckboxView as CheckboxViewImport,
  CheckboxViewProps,
  SupplementalScreenProps,
} from './CheckboxView';

type Props = SupplementalScreenProps & {
  CheckboxView?: React.ComponentType<CheckboxViewProps>;
};

export const CheckboxSupplementalScreen = ({
  fields,
  onSubmit,
  CheckboxView = CheckboxViewImport,
}: Props) => {
  const { sendViewInteractionEvent } = usePageViewEvents({
    pageView: PageView.SUPPLEMENTAL_CHECKBOX_SCREEN,
  });

  const handleSubmitWithAnalytics = useCallback(
    (values: SubmitProviderInputsPayload) => {
      sendViewInteractionEvent({
        interaction: UserInteractionEvent.SUBMIT_SUPPLEMENTAL_INFORMATION,
      });
      onSubmit(values);
    },
    [onSubmit, sendViewInteractionEvent]
  );

  return <CheckboxView fields={fields} onSubmit={handleSubmitWithAnalytics} />;
};
